import appInfo from 'js/lib/appInfo';

import {
  AUTHENTICATION_MODAL_MODES,
  type AUTHENTICATION_MODAL_MODES_KEY,
} from 'bundles/authentication-common/constants';
import sessionStorageEx from 'bundles/common/utils/sessionStorageEx';
import inServerContext from 'bundles/ssr/util/inServerContext';

export const SIGNUP_ABANDON_ON_LOHP_TIMESTAMP_KEY = 'signup-abandon-on-lohp-timestamp';

const LOHP_APP_NAME = 'front-page';
const VALID_MODAL_MODES = [AUTHENTICATION_MODAL_MODES.SIGNUP, AUTHENTICATION_MODAL_MODES.SIGNUPCONTINUE];

/**
 * Sets the signup abandon on LOHP timestamp in sessionStorage to
 * track when a user abandons the signup process on LOHP
 */
export const setSignupAbandonOnLOHPTimestamp = (): void => {
  if (inServerContext || !sessionStorageEx.isAvailable()) {
    return;
  }

  const timestamp = Date.now();
  sessionStorageEx.setItem(SIGNUP_ABANDON_ON_LOHP_TIMESTAMP_KEY, timestamp, String);
};

/**
 * Sets the signup abandon on LOHP timestamp in sessionStorage to
 * track when a user abandons the signup process on LOHP
 * Only sets the timestamp if the user is on LOHP and the modal mode is valid
 * @param modalMode - The modal mode that the user is on (signup, login, logincontinue, signupcontinue etc.)
 */
export const setLOHPSignupAbandonSignal = ({ modalMode }: { modalMode: AUTHENTICATION_MODAL_MODES_KEY }): void => {
  const appName = appInfo.get().appName || '';
  if (appName !== LOHP_APP_NAME || !VALID_MODAL_MODES.includes(modalMode)) {
    return;
  }

  setSignupAbandonOnLOHPTimestamp();
};

/**
 * Gets the signup abandon timestamp from sessionStorage
 * @returns timestamp number or null if not found
 */
export const getSignupAbandonOnLOHPTimestamp = (): number | null => {
  if (inServerContext || !sessionStorageEx.isAvailable()) {
    return null;
  }

  const timestamp = sessionStorageEx.getItem(SIGNUP_ABANDON_ON_LOHP_TIMESTAMP_KEY, String, null);
  if (!timestamp) {
    return null;
  }

  const parsed = parseInt(timestamp, 10);
  return Number.isNaN(parsed) ? null : parsed;
};

export const clearSignupAbandonOnLOHPTimestamp = (): void => {
  if (inServerContext || !sessionStorageEx.isAvailable()) {
    return;
  }

  sessionStorageEx.removeItem(SIGNUP_ABANDON_ON_LOHP_TIMESTAMP_KEY);
};
